import React from "react";
import { ExternalLink, Gavel } from "lucide-react";

export const RecentSales = ({ sales, format }) => {
  if (!sales?.length) return null;
  return (
    <div data-testid="recent-sales-section" className="border border-white/10 bg-[#111113] rounded-xl p-6">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-zinc-500">Recent eBay Sales</span>
        <span className="text-[10px] text-zinc-600">{sales.length} real sold results · last 90 days</span>
      </div>
      <div className="mt-4 space-y-0.5 max-h-80 overflow-y-auto pr-1">
        {sales.map((s, i) => (
          <a
            key={s.url || i}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            data-testid={`recent-sale-row-${i}`}
            className="flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-white/5 transition-colors group"
          >
            {s.thumbnail ? (
              <img src={s.thumbnail} alt="" loading="lazy" className="w-9 h-9 rounded object-cover bg-black/40 shrink-0" />
            ) : (
              <div className="w-9 h-9 rounded bg-black/40 shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-xs text-zinc-300 truncate">{s.title}</p>
              <p className="text-[10px] text-zinc-500 flex items-center gap-1.5 mt-0.5">
                {s.graded ? (
                  <span data-testid={`recent-sale-graded-badge-${i}`} className="px-1.5 py-0.5 rounded bg-[#F59E0B]/15 text-[#F59E0B] font-semibold uppercase tracking-wide">
                    {[s.grade_company, s.grade].filter(Boolean).join(" ") || "Graded"}
                  </span>
                ) : (
                  <span data-testid={`recent-sale-raw-badge-${i}`} className="px-1.5 py-0.5 rounded bg-emerald-500/10 text-emerald-300 font-semibold uppercase tracking-wide">
                    Raw
                  </span>
                )}
                {s.date ? <span>{new Date(s.date).toLocaleDateString()}</span> : null}
                {s.buying_format === "auction" && (
                  <span className="flex items-center gap-0.5"><Gavel className="w-2.5 h-2.5" />{s.bid_count != null ? `${s.bid_count} bids` : "auction"}</span>
                )}
              </p>
            </div>
            <span data-testid={`recent-sale-price-${i}`} className="font-mono-plex text-sm font-semibold text-zinc-200 shrink-0">
              {format(s.price)}
            </span>
            <ExternalLink className="w-3 h-3 text-zinc-600 group-hover:text-zinc-300 shrink-0" />
          </a>
        ))}
      </div>
      <p className="mt-3 text-[10px] text-zinc-600">Actual completed eBay sales — click any sale to view the original listing.</p>
    </div>
  );
};

export default RecentSales;
